<div class="additional-section" *ngIf="sectionVisible">

  <div class="additional-section__section"
       *ngFor="let section of config.sections; let i = index"
       [ngClass]="{'additional-section__section--hidden': isSectionHidden(i)}">
      <ng-container *ngFor="let item of section.contents">
        <ng-container [ngSwitch]="item.type">

          <h1 *ngSwitchCase="ContentType.HEADING_1"
              [class]="'additional-section__title' + (item.cssClass ? ' ' + item.cssClass : '')"
              [innerHTML]="item.content | translate | safeHtml">
          </h1>

          <h2 *ngSwitchCase="ContentType.HEADING_2"
              [class]="'additional-section__subtitle' + (item.cssClass ? ' ' + item.cssClass : '')"
              [innerHTML]="item.content | translate | safeHtml">
          </h2>

          <h3 *ngSwitchCase="ContentType.HEADING_3"
              [class]="'additional-section__heading-3' + (item.cssClass ? ' ' + item.cssClass : '')"
              [innerHTML]="item.content | translate | safeHtml">
          </h3>

          <p *ngSwitchCase="ContentType.PARAGRAPH"
             [class]="item.cssClass ? item.cssClass : ''"
             [innerHTML]="item.content | translate | safeHtml">
          </p>

          <ul *ngSwitchCase="ContentType.LIST"
              [class]="item.cssClass ? item.cssClass : ''"
              [innerHTML]="item.content | translate | safeHtml">
          </ul>

            <ol *ngSwitchCase="ContentType.ORDERED_LIST"
                [class]="item.cssClass ? item.cssClass : ''"
                [innerHTML]="item.content | translate | safeHtml">
            </ol>

          <table *ngSwitchCase="ContentType.TABLE"
                 [class]="item.cssClass ? item.cssClass : ''"
                 [innerHTML]="item.content | translate | safeHtml">
          </table>

        </ng-container>
      </ng-container>

      <div *ngIf="i === SECTION_BEFORE_EXPAND_INDEX && expandButtonVisible" class="expand__container">
        <button
                class="btn btn--expand"
                [ngClass]="{ 'btn--expanded': contentExpanded }"
                (click)="toggleExpanded()"
        >
          <span *ngIf="contentExpanded" class="btn__label">{{ 'collapse' | translate }}</span>
          <i *ngIf="contentExpanded" class="material-icons">
            keyboard_arrow_up
          </i>
          <i *ngIf="!contentExpanded" class="material-icons icon">
            keyboard_arrow_down
          </i>
        </button>
      </div>
  </div>

</div>
